
<row :class="classes">
  <column :size="pinnedColumnSize" class="pinned-column" v-if="hasPinnedColumns && horizontal">
    <scroll-area v-if="listView" ref="pinnedColumn" @scroll.passive="syncScroll($event, 'table')" class="list-view-table horizontal-table">
      <matrix
        fetching-message="No results found."
        allow-horizontal
        v-sticky-header
        ref="table"
        :has-data="entries.length > 0">
        <template #table-header>
          <template v-for="column in pinnedColumns">
            <t-column v-if="pagination && column.sorted_by_ids.length > 0" :size="columnWidthClass(column.x_size)" :key="column.id" is-heading>
              <sort-column :value="column.sorted_by_ids[0]" v-bind="pagination.sortAsJson()" @click="updateSort">
                {{column.label_title}}
              </sort-column>
            </t-column>
            <t-column is-heading v-else :key="column.id" :size="columnWidthClass(column.x_size)">
              {{column.label_title}}
            </t-column>
          </template>
        </template>
        <template #table-body>
          <list-view-content-element-row
            v-for="entry in entries"
            :is-in-detail-view-edit-mode="isInDetailViewEditMode"
            :key="entry.id"
            :entry="entry"
            :list-view="listView"
            :content-element="listView.firstRow"
            :nested-elements="pinnedColumns">
          </list-view-content-element-row>
        </template>
      </matrix>
    </scroll-area>
  </column>
  <column class="unpinned-columns" :style="unpinnedColumnSize">
    <scroll-area v-if="listView"
                 :id="`${scrollbarId}-1`"
                 ref="table"
                 v-sticky-scrollbar="`${scrollbarId}-2`"
                 :allow-horizontal="horizontal"
                 with-infinite-scroll
                 :class="{'horizontal-table': horizontal}"
                 class="smooth"
                 @scroll.passive="syncScroll($event, 'pinnedColumn')">
      <component :is="infiniteScrollerOrDiv" @loadMore="fetchEntries" :busy="entriesBusy" :fullyLoaded="ObjectModelEntriesFullyLoaded">
        <matrix
          :id="`${scrollbarId}-2`"
          v-sticky-header
          ref="content"
          fetching-message="No results found."
          :allow-horizontal="horizontal"
          :table-body-size="unpinnedTableBodySize"
          class="list-view-table fds"
          :has-data="entries.length > 0">
          <template #table-header>
            <t-prefix v-if="canTakeBulkActions"/>
            <template v-for="column in tableColumns">
              <t-column v-if="pagination && column.sorted_by_ids.length > 0" :size="columnWidthClass(column.x_size)" :key="column.id" is-heading>
                <sort-column  :value="column.sorted_by_ids[0]" v-bind="pagination.sortAsJson()" @click="updateSort">
                  {{column.label_title}}
                </sort-column>
              </t-column>
               <t-column is-heading v-else :key="column.id" :size="columnWidthClass(column.x_size)">
                {{column.label_title}}
              </t-column>
            </template>
          </template>
          <template #table-body>
            <bulk-action-header
              v-if="canTakeBulkActions"
              :list-view="listView">
            </bulk-action-header>
            <list-view-content-element-row
              v-for="entry in entries"
              :key="entry.id"
              :entry="entry"
              :horizontal="horizontal"
              :is-in-detail-view-edit-mode="isInDetailViewEditMode"
              :list-view="listView"
              :content-element="listView.firstRow"
              :nested-elements="tableColumns">
            </list-view-content-element-row>
          </template>
        </matrix>
      </component>
    </scroll-area>
  </column>
</row>

